import { AllocationChange } from '@/types/vehicleAllocation'
import { UniqueIdentifier } from '@dnd-kit/core'
import { create } from 'zustand'

interface Store {
    allocationChanges: AllocationChange[]
    swappedBuses: string[]
    activeId: UniqueIdentifier | null
    routeEditing: string | null
    runsWithErrors: string[]
}

interface Actions {
    setAllocationChanges: (allocationChanges: AllocationChange[]) => void
    setSwappedBuses: (swappedBuses: string[]) => void
    setActiveId: (activeId: UniqueIdentifier | null) => void
    setRouteEditing: (routeEditing: string | null) => void
    setRunsErrors: (runsWithErrors: string[]) => void
    clearStore: () => void
}

export const useVehicleAllocationStore = create<Store & Actions>((set) => ({
    allocationChanges: [],
    swappedBuses: [],
    activeId: null,
    routeEditing: null,
    runsWithErrors: [],
    setAllocationChanges: (allocationChanges: AllocationChange[]) => set({ allocationChanges }),
    setSwappedBuses: (swappedBuses: string[]) => set({ swappedBuses }),
    setActiveId: (activeId: UniqueIdentifier | null) => set({ activeId }),
    setRouteEditing: (routeEditing: string | null) => set({ routeEditing }),
    setRunsErrors: (runsWithErrors: string[]) => set({ runsWithErrors }),
    clearStore: () =>
        set({ allocationChanges: [], swappedBuses: [], activeId: null, routeEditing: null, runsWithErrors: [] }),
}))
